import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { ButtonContainer } from "./Action.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import AddEditPaymentTerms from "../../../AddEditPaymentTerms";
import "../../PaymentTermsList.scss";

const Action = (props) => {
  const { t, data, onRefreshData, updateRefeshStatus } = props;
  const [isAddPaymentTermPopupVisible, setAddPaymentTermPopupVisible] =
    useState(false);
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const handleDisable = () => {
    setConfirmVisibility(true);
  };

  const editPaymentTerms = () => {
    setAddPaymentTermPopupVisible(true);
  };
  const closePaymentTermsCreationPopup = () => {
    setAddPaymentTermPopupVisible(false);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };
  useEffect(() => {
    if (isConfirm) {
      const formStatus = data.isActive ? "0" : 1;
      if (data.isActive === 1) {
        axios
          .delete(`/general/paymentTerms/${data.id}`)
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => handleApiError(error));
      } else {
        axios
          .put(`/general/paymentTerms/${data.id}`, {
            ...data,
            country: JSON.stringify(data.country),
            isActive: formStatus,
          })
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => handleApiError(error));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <ButtonContainer>
      <div>
        <Image
          src={editIcon}
          onClick={editPaymentTerms}
          title={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          alt={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          className="paymentTerms-list__image-icon"
        />
        {data.isActive == 1 && (
          <Image
            src={deleteIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            title={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            className="paymentTerms-list__image-icon"
          />
        )}
        {data.isActive == 0 && (
          <Image
            src={activateIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            title={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            className="paymentTerms-list__image-icon"
          />
        )}
      </div>

      {isAddPaymentTermPopupVisible && (
        <AddEditPaymentTerms
          title={t("PAYMENT_TERMS")}
          onClose={closePaymentTermsCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          selectedPaymentTerm={data}
          isEditMode
          id={data.id}
        />
      )}
      {isConfirmVisible && (
        <WarningPopUp
          title={
            data.isActive == 0
              ? t("PAYMENT_TERMS_CONFIRMATION_BOX_ENABLE")
              : t("PAYMENT_TERMS_CONFIRMATION_BOX_DELETE")
          }
          message={
            data.isActive == 0
              ? t("PAYMENT_TERMS_CONFIRMATION_BOX_ENABLE_CONTENT")
              : t("PAYMENT_TERMS_CONFIRMATION_BOX_DELETE_CONTENT")
          }
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

Action.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(Action);
